import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { PolygonTransitionBanner } from "./components/PolygonTransitionBanner";
import { Marketplace } from "./pages/Marketplace";
import { RecentlySold } from "./pages/RecentlySold";
import { AssetDetail } from "./pages/AssetDetail";
import { Inventory } from "./pages/Inventory";
import { Mint } from "./pages/Mint";
import { Drops } from "./pages/Drops";
import { CreateNft } from "./pages/CreateNft";
// Polygon pulls in viem; load it only when someone opens the Polygon page.
const PolygonCreate = lazy(() => import("./pages/PolygonCreate").then((m) => ({ default: m.PolygonCreate })));
const PolygonGallery = lazy(() => import("./pages/PolygonGallery").then((m) => ({ default: m.PolygonGallery })));
import { Create } from "./pages/Create";
import { BulkCreate } from "./pages/BulkCreate";
import { CreateDrop } from "./pages/CreateDrop";
import { Admin } from "./pages/Admin";
import { Tutorials } from "./pages/Tutorials";
import { Developers } from "./pages/Developers";
import { Forum } from "./pages/Forum";
import { ForumThread } from "./pages/ForumThread";
import { NotFound } from "./pages/NotFound";
import { Exchange } from "./pages/Exchange";
import { ExchangeMarket } from "./pages/ExchangeMarket";
import { WalletProvider } from "./wallet/WalletContext";
import { DialogHost } from "./components/Dialog";
import { SalesTicker } from "./components/SalesTicker";
import { XMentionsTicker } from "./components/XMentionsTicker";

export default function App() {
  return (
    <WalletProvider>
      <PolygonTransitionBanner />
      <Header />
      <main className="main">
        <Routes>
          <Route path="/" element={<Marketplace />} />
          <Route path="/recently-sold" element={<RecentlySold />} />
          <Route path="/asset/:assetId" element={<AssetDetail />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/mint" element={<Mint />} />
          <Route path="/drops" element={<Drops />} />
          <Route path="/create" element={<CreateNft />} />
          <Route
            path="/create/polygon"
            element={
              <Suspense fallback={<div className="state-message">Loading…</div>}>
                <PolygonCreate />
              </Suspense>
            }
          />
          <Route
            path="/polygon"
            element={
              <Suspense fallback={<div className="state-message">Loading…</div>}>
                <PolygonGallery />
              </Suspense>
            }
          />
          <Route path="/create-advanced" element={<Create />} />
          <Route path="/create-bulk" element={<BulkCreate />} />
          <Route path="/create-drop" element={<CreateDrop />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/developers" element={<Developers />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/forum/t/:threadId" element={<ForumThread />} />
          <Route path="/exchange" element={<Exchange />} />
          <Route path="/exchange/:marketId" element={<ExchangeMarket />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer className="footer">
        <p>
          WAXCreator is an independent NFT creation and marketplace tool, not affiliated with AtomicHub. Token
          backing is handled by a separate, self-serve escrow contract, not the core AtomicAssets protocol.
        </p>
      </footer>
      <SalesTicker />
      <XMentionsTicker />
      <DialogHost />
    </WalletProvider>
  );
}
